export default __webpack_public_path__ + "static/media/attempts-limit-card.d5427017.svg";